import React, { useState } from "react";
import PaginationButtons from "../../../CommonComponents/PaginationButtons";
import PageEntries from "../../../CommonComponents/PageEntries";
import ExcelButton from "../../../CommonComponents/ExcelButton";
import { useYojnaBeneficialMemberDataPagination } from "../../../API_Master/FetchAPI";
import BeneficiaryTableShimmerEffect from "./BeneficiaryTableShimmerEffect";
import { useBeneficialMemberDataExportExcel } from "../../../API_Master/ExcelAPI";
import { exportBeneficiaryToPDF, exportBenifeciaryExcel, exportToExcel, notifyError, toIndianCurrency } from "../../../MethodMaster/JSXComponentMothod";
import { toast } from "react-toastify";

export default function BeneficiaryTable({ selVillage, selYojna, title, tab, Vidhansabha }) {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [currentExportType, setCurrentExportType] = useState();
  // Filter state (only applied when user clicks "Apply")
  const [tempName, setTempName] = useState("");
  const [tempMobile, setTempMobile] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({ name: "", mobile: "" });

  const {
    data: BeneficialMemberData,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isError,
    refetch,
  } = useYojnaBeneficialMemberDataPagination(
    !!(selYojna && selVillage),
    rowsPerPage,
    selYojna?.GramYojnaID || null,
    selVillage?.VillageNameEnglish || null,
    appliedFilters.name,
    appliedFilters.mobile,
    Vidhansabha,
  );

  const pages = BeneficialMemberData?.pages || [];
  const totalCount = BeneficialMemberData?.pages[0]?.TotalCount || 0;
  const currentItems = pages[currentPage]?.data || [];
  const start = currentPage * rowsPerPage + 1;
  const end = Math.min(start + currentItems.length - 1, totalCount);

  const handleApplyFilters = () => {
    setCurrentPage(0);
    setAppliedFilters({
      name: tempName.trim(),
      mobile: tempMobile.trim(),
    });
    setIsFilterOpen(false);
  };

  const handleClearFilters = () => {
    setTempName("");
    setTempMobile("");
    setAppliedFilters({ name: "", mobile: "" });
    setCurrentPage(0);
    setIsFilterOpen(false);
  };

  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  const goToPage = async (index) => {
    if (pages[index]) setCurrentPage(index);
    else if (hasNextPage) {
      await fetchNextPage();
      setCurrentPage(index);
    }
  };

  const { mutate: exportMemberList, isPending: isExporting } = useBeneficialMemberDataExportExcel(Vidhansabha);
  const handleExport = () => {
    toast.dismiss();
    exportMemberList(
      {
        GramYojnaID: selYojna?.GramYojnaID,
        VillageName: selVillage?.VillageNameEnglish,
        Name: appliedFilters.name,
        MobileNo: appliedFilters.mobile,
      },
      {
        onSuccess: (data) => {
          if (!data?.length) return notifyError("No Data Found");

          const exportData = data.map((item, i) => ({
            "Sr No": i + 1,
            નામ: item.FullNameEnglish,
            મોબાઇલ: item.MobileNo,
            "ચૂકવેલ રકમ": item?.TotalAmount ? "₹ " + item?.TotalAmount?.toLocaleString() : "",
            "સ્થાન / વિસ્તાર": item.LocalityEnglish,
          }));

          exportBenifeciaryExcel(exportData, `Labharthi_${selVillage.VillageNameEnglish}`, {
            selYojna: selYojna || "Labharthi List",
            selVillage: selVillage || "",
            tab,
          });
        },
        onError: () => notifyError("Export failed"),
      },
    );
  };
  const handlePDFExport = () => {
    toast.dismiss();
    exportMemberList(
      {
        GramYojnaID: selYojna?.GramYojnaID,
        VillageName: selVillage?.VillageNameEnglish,
        Name: appliedFilters.name,
        MobileNo: appliedFilters.mobile,
      },
      {
        onSuccess: (data) => {
          if (!data?.length) return notifyError("No Data Found");

          const exportData = data.map((item, i) => ({
            "Sr No": i + 1,
            Name: item.FullNameEnglish || "-",
            Mobile: item.MobileNo || "-",
            Locality: item.LocalityEnglish || "-",
          }));

          exportBeneficiaryToPDF(exportData, {
            yojnaName: selYojna?.GramYojnaName || "Labharthi List",
            villageName: selVillage?.VillageNameEnglish || "",
            fileName: `Labharthi_${selVillage?.VillageNameEnglish || "List"}`,
            BeneficialCount: selVillage.BeneficialCount || "",
            TotalAmount: selVillage.TotalAmount || "",
          });

          // toast.success("PDF downloaded successfully!");
        },
        onError: () => notifyError("Export failed"),
      },
    );
  };
  const handleCurrentFileExportType = (type) => {
    setCurrentExportType(type);
    if (type === "PDf") {
      handlePDFExport();
    } else if (type === "Excel") {
      handleExport();
    }
  };
  return (
    <>
      {(isLoading && !appliedFilters.name && !appliedFilters.mobile) || isError ? (
        <BeneficiaryTableShimmerEffect title={title} />
      ) : (
        <div className="govdash-tableContainer">
          {/* Header */}
          <div className="govdash-tableHeader">
            <h2 className="govdash-sectionTitle">{title}</h2>

            <div className="govdash-tableActions">
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.85rem" }}>
                {" "}
                <span style={{ whiteSpace: "nowrap" }}>Show</span>
                <select
                  value={rowsPerPage}
                  onChange={handleRowsChange}
                  style={{
                    padding: "0.35rem 0.5rem",
                    borderRadius: "0.35rem",
                    border: "1px solid #d1d5db",
                    background: "#fff",
                    fontSize: "0.8rem",
                    minWidth: "60px",
                  }}
                >
                  {[10, 25, 50, 100].map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                <span style={{ whiteSpace: "nowrap" }}>entries</span>
              </div>

              <button onClick={() => setIsFilterOpen(true)} className="govdash-btn-outline">
                <i className="fas fa-filter"></i> Filter
                {(appliedFilters.name || appliedFilters.mobile) && <span className="govdash-filterBadge">!</span>}
              </button>
              <ExcelButton isExportingMain={isExporting && currentExportType == "Excel"} handleExportMain={() => handleCurrentFileExportType("Excel")} primaryExcel="Download" />
              {/* <button
                onClick={() => handleCurrentFileExportType("PDf")}
                disabled={isExporting && currentExportType == "PDF"}
                className="govdash-pdfBtn"
                style={{ marginLeft: '0.5rem' }}
              >
                <i className="fas fa-file-pdf"></i>
                {isExporting ? 'Exporting...' : 'Download PDF'}
              </button> */}
            </div>
          </div>

          {/* Table */}
          <div className="govdash-tableWrapper">
            <table className="govdash-table">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Amount Disbursed</th>
                  <th>Locality</th>
                </tr>
              </thead>
              <tbody>
                {isFetching && currentItems.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="text-center py-5">
                      Searching...
                    </td>
                  </tr>
                ) : currentItems.length > 0 ? (
                  currentItems.map((item, i) => (
                    <tr key={item.VoterID}>
                      <td>{start + i}</td>
                      <td>{item.FullNameEnglish}</td>
                      <td>{item.MobileNo || "-"}</td>
                      {/* <td>{ item?.TotalAmount ?  ("₹ "+ item?.TotalAmount?.toLocaleString() ) :'-'}</td> */}
                      <td>{item?.TotalAmount ? toIndianCurrency(parseFloat(item?.TotalAmount)) : "-"}</td>
                      <td>{item.LocalityEnglish || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center py-5 text-gray-500">
                      {appliedFilters.name || appliedFilters.mobile ? "No results found" : "No data"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="row mx-3 justify-content-between">
              <PageEntries start={start} end={end} totalCount={totalCount} />
              <PaginationButtons
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                goToPage={goToPage}
                pages={pages}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
              />
            </div>
          </div>

          {/* SLIDE-IN FILTER PANEL */}
          <div className={`govdash-filterSidebar ${isFilterOpen ? "open" : ""}`}>
            <div className="govdash-filterHeader">
              <span>
                <i className="fas fa-filter"></i> Filter Labharthi
              </span>
              <button onClick={() => setIsFilterOpen(false)} className="govdash-closeBtn">
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="govdash-filterBody">
              <div className="govdash-inputGroup">
                <label>Search by Name</label>
                <input type="text" placeholder="Enter name..." value={tempName} onChange={(e) => setTempName(e.target.value)} />
              </div>
              <div className="govdash-inputGroup">
                <label>Search by Mobile</label>
                <input type="text" placeholder="Enter mobile number..." value={tempMobile} onChange={(e) => setTempMobile(e.target.value.replace(/\D/g, "").slice(0, 10))} />
              </div>
            </div>
            <div className="govdash-filterFooter">
              <button onClick={handleClearFilters} className="govdash-btn-secondary">
                Clear
              </button>
              <button onClick={handleApplyFilters} className="govdash-btn-primary">
                Apply Filters
              </button>
            </div>
          </div>

          {/* Overlay */}
          {isFilterOpen && <div className="govdash-sidebarOverlay" onClick={() => setIsFilterOpen(false)}></div>}
        </div>
      )}
    </>
  );
}
